import Joi from 'joi';

import { requiredInteger } from '../../../../../../../../../../utils/validators';
import { FormValues } from './types';

export const validationSchema = Joi.object<FormValues, true>({
  awardPoints: requiredInteger.min(1),
});
